import { render } from "./ProjectGallery.vue?vue&type=template&id=6a2d3316&ts=true&lang=pug"
import script from "./ProjectGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectGallery.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__